import { render } from "./Start.vue?vue&type=template&id=495d1c6e"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__